import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-lg font-medium 2xl:text-2xl" }
const _hoisted_2 = { class: "text-muted-foreground text-[10px] leading-none" }

import Icon from '@/components/Icon.vue';
    import type { StatItem } from '@/types';
    import { computed, ref } from 'vue';
    import type { Table } from '@tanstack/vue-table';
    import type { DashboardTableData } from '@/types';
    import { useDashboardStore } from '@/stores/dashboard';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardStat',
  props: {
    table: {},
    item: {}
  },
  setup(__props: any) {

    const props = __props;

    const dashboardStore = useDashboardStore();

    const isActive = computed(() => dashboardStore.activeFilterKey === props.item.key);

    const hasFilterValues = computed(() => {
        return props.item.filter && !!props.item.filter.value.length;
    });

    const handleClick = () => {
        if (dashboardStore.activeFilterKey === props.item.key || props.item.isReset) {
            props.table?.resetColumnFilters();
            dashboardStore.resetActiveFilter();
        } else {
            props.table?.setColumnFilters([props.item.filter]);
            dashboardStore.setActiveFilter(props.item);
        }
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex max-w-[200px] shrink-0 items-center gap-2 rounded-md border px-1 2xl:shrink", [
            isActive.value ? 'bg-destructive/5 border-destructive/10' : 'border-transparent',
            (_ctx.item.isReset || hasFilterValues.value) ? 'cursor-pointer' : 'pointer-events-none',
        ]]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.isReset || hasFilterValues.value) && handleClick()))
  }, [
    (_ctx.item.customIcon)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.item.customIcon), {
          key: 0,
          className: "text-destructive size-4 shrink-0 2xl:size-6"
        }))
      : (_ctx.item.icon)
        ? (_openBlock(), _createBlock(Icon, {
            key: 1,
            name: _ctx.item.icon,
            class: "text-destructive size-4 shrink-0 2xl:size-6"
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.item.value), 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.item.description), 1)
  ], 2))
}
}

})